import { c as _c } from "react/compiler-runtime";
import { useUser } from '@auth0/nextjs-auth0';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { TRPC_SETTINGS } from '~/constants/trpc';
import { useToast } from '~/hooks/useToasts';
import { api } from '~/libs/api';
import { logError } from '~/utils/logger';
import { useSharedRouter } from '~/utils/nextMigration/router';
export const useTripSave = tripId => {
  const $ = _c(38);
  const t = useTranslations("journey");
  const toast = useToast();
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const {
    user
  } = useUser();
  const router = useSharedRouter();
  const t0 = tripId ?? "";
  let t1;
  if ($[0] !== t0) {
    t1 = {
      tripId: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !!user && !!tripId;
  let t3;
  if ($[2] !== t2) {
    t3 = {
      enabled: t2,
      ...TRPC_SETTINGS.QUERY_NO_REFETCH
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    data: isTripSaved,
    refetch
  } = api.account.isTripSaved.useQuery(t1, t3);
  let t4;
  if ($[4] !== refetch || $[5] !== toast) {
    t4 = title => {
      toast?.add({
        title,
        variant: "success",
        position: "middle"
      }, {
        timeout: 5000
      });
      return refetch();
    };
    $[4] = refetch;
    $[5] = toast;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const showSuccess = t4;
  let t5;
  if ($[7] !== t || $[8] !== toast) {
    t5 = () => {
      logError("Error updating saved trip");
      toast?.add({
        title: t("overview_save_trip_error"),
        variant: "error",
        position: "middle"
      }, {
        timeout: 5000
      });
    };
    $[7] = t;
    $[8] = toast;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const showError = t5;
  let t6;
  if ($[10] !== showSuccess || $[11] !== t) {
    t6 = () => showSuccess(t("overview_save_trip_success"));
    $[10] = showSuccess;
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== showError || $[14] !== t6) {
    t7 = {
      onSuccess: t6,
      onError: showError
    };
    $[13] = showError;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const saveTrip = api.account.saveTrip.useMutation(t7);
  let t8;
  if ($[16] !== showSuccess || $[17] !== t) {
    t8 = () => showSuccess(t("overview_save_trip_removed"));
    $[16] = showSuccess;
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== showError || $[20] !== t8) {
    t9 = {
      onSuccess: t8,
      onError: showError
    };
    $[19] = showError;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const removeTrip = api.account.removeTrip.useMutation(t9);
  const isPending = saveTrip.isPending || removeTrip.isPending;
  let t10;
  if ($[22] !== isPending || $[23] !== isTripSaved || $[24] !== removeTrip || $[25] !== saveTrip || $[26] !== tripId || $[27] !== user) {
    t10 = () => {
      if (!tripId || isPending) {
        return;
      }
      if (!user) {
        setIsLoginOpen(true);
        return;
      }
      if (isTripSaved) {
        removeTrip.mutate({
          tripId
        });
      } else {
        saveTrip.mutate({
          tripId,
          notify: true,
          tripPageUrl: typeof window !== "undefined" ? window.location.href : ""
        });
      }
    };
    $[22] = isPending;
    $[23] = isTripSaved;
    $[24] = removeTrip;
    $[25] = saveTrip;
    $[26] = tripId;
    $[27] = user;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  const handleSave = t10;
  let t11;
  if ($[29] !== router || $[30] !== tripId) {
    t11 = () => {
      if (!tripId) {
        return;
      }
      router.push(`/auth/login?returnTo=/account?tripId=${tripId}`);
    };
    $[29] = router;
    $[30] = tripId;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  const handleLogin = t11;
  let t12;
  if ($[32] !== handleLogin || $[33] !== handleSave || $[34] !== isLoginOpen || $[35] !== isPending || $[36] !== isTripSaved) {
    t12 = {
      isTripSaved,
      isPending,
      isLoginOpen,
      setIsLoginOpen,
      handleSave,
      handleLogin
    };
    $[32] = handleLogin;
    $[33] = handleSave;
    $[34] = isLoginOpen;
    $[35] = isPending;
    $[36] = isTripSaved;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  return t12;
};